import { Middleware } from "redux";
import { createStore, applyMiddleware, compose } from "redux";
import { createLogger } from "redux-logger";
import thunkMiddleware from "redux-thunk";
import reducer from "./reducers";
import { ENABLE_REDUX_LOGGER } from "./actions/dashboard/env.variables";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default ENABLE_REDUX_LOGGER === "true"
    ? createStore(
        reducer,
        composeEnhancers(
            applyMiddleware(
                thunkMiddleware as Middleware,
                loggerMiddleware as Middleware
            )
        )
    )
    : createStore(
        reducer,
        composeEnhancers(applyMiddleware(thunkMiddleware as Middleware))
    );
